/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Newsletter - Scroll to it after submit
if (window.location.href.indexOf('?customer_posted=true') > -1) {
    setTimeout(() => {
        document.querySelector('.newsletter-form').scrollIntoView()
    }, 750)
}

// Fix for product list items inside offcanvas mobile menu
document.querySelectorAll('#offcanvas-menu-upsell-collection .btn-atc').forEach(($btn) => {
    $btn.addEventListener('click', () => {
        const offcanvas = bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-mobile-menu')
        offcanvas.hide()
    })
})

/*
    Navbar menu items open on hover (not click)
*/
document.querySelectorAll('#navbar .navbar-nav .nav-link.dropdown-toggle').forEach(($item) => {
    $item.addEventListener('mouseenter', () => {
        document.querySelectorAll('#navbar .navbar-nav .nav-link.dropdown-toggle').forEach(($item) => {
            $item.classList.remove('show')
            $item.setAttribute('aria-expaned', 'false')
            $item.nextElementSibling.classList.remove('show')
        })

        $item.classList.add('show')
        $item.setAttribute('aria-expaned', 'true')
        $item.nextElementSibling.classList.add('show')
        $item.nextElementSibling.setAttribute('data-bs-popper', 'none')
    })
    $item.addEventListener('mouseleave', () => {
        if (!$item.nextElementSibling.matches(':hover')) {
            $item.classList.remove('show')
            $item.setAttribute('aria-expaned', 'false')
            $item.nextElementSibling.classList.remove('show')
        }
    })

    $item.addEventListener('click', (e) => {
        window.location.href = $item.getAttribute('href')
    })
})
document.querySelector('#main').addEventListener('mouseenter', () => {
    document.querySelectorAll('#navbar .navbar-nav .nav-link.dropdown-toggle').forEach(($item) => {
        $item.classList.remove('show')
        $item.setAttribute('aria-expaned', 'false')
        $item.nextElementSibling.classList.remove('show')
    })
})

// Handle Plus/Minus in quantity steppers
window.qtyDecrease = (btn) => {
    const input = btn.closest('.quantity-wrapper').querySelector('input')
    const inputValue = Number(input.value)

    if (inputValue > 1) {
        input.setAttribute('value', inputValue - 1)
        input.dispatchEvent(new Event('change'))
    }
}
window.qtyIncrease = (btn) => {
    const input = btn.closest('.quantity-wrapper').querySelector('input')
    const inputValue = Number(input.value)

    input.setAttribute('value', inputValue + 1)
    input.dispatchEvent(new Event('change'))
}
// Offcanvas wishlist - Open it if URL contains '#wishlist'
if (window.location.hash.includes('#wishlist')) {
    const offcanvasWishlist = bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-wishlist')
    offcanvasWishlist.show()
}

// Gorgias chat - widget adjustments on various occasions
document.querySelectorAll('.offcanvas').forEach(offcanvas => {
    offcanvas.addEventListener('show.bs.offcanvas', () => {
        const el = document.querySelector('#gorgias-chat-container')
        if (el) {
            el.style.display = 'none'
        }
    })
})

document.querySelectorAll('.offcanvas').forEach(offcanvas => {
    offcanvas.addEventListener('hide.bs.offcanvas', () => {
        const el = document.querySelector('#gorgias-chat-container')
        if (el) {
            el.style.display = 'block'
        }
    })
})
